import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import * as types from '@phoenix/store/mutations-types';

export default {
  props: {
    resultPageHref: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      searchValue: '',
      watchTitle: '',
      resultPageUrl: 'reference',
      isOnResultPage: false,
    };
  },

  computed: {
    ...mapState('strapSearch', ['watchReference', 'isLoading', 'watchExists']),
    ...mapGetters('strapSearch', ['hasResult']),

    isSearchReferenceBtnDisabled() {
      return !this.searchValue || this.searchValue === '';
    },

    searchResultLink() {
      const url = new URL(this.resultPageHref);
      url.searchParams.set(this.resultPageUrl, this.searchValue);
      return url;
    },
  },

  created() {
    window.addEventListener('popstate', async (state) => {
      if (state?.state && this.isOnResultPage) {
        this.searchValue = state.state.reference ?? '';
        this.STRAP_SEARCH_SET_WATCH_REF(this.searchValue);
        await this.getStrapFromWatchReference();
      }
    });
  },

  async mounted() {
    this.isOnResultPage = window.location.href.includes(this.resultPageHref);

    if (this.isOnResultPage) {
      const urlParams = new URLSearchParams(window.location.search);
      this.searchValue = urlParams.get(this.resultPageUrl) ?? '';
    }
  },

  methods: {
    ...mapActions('strapSearch', ['getStrapFromWatchReference', 'getAllStraps']),
    ...mapMutations('strapSearch', [types.STRAP_SEARCH_SET_WATCH_REF]),

    async getStraps() {
      if (this.watchReference) {
        await this.getStrapFromWatchReference();
      } else {
        await this.getAllStraps();
      }
    },

    async onSubmit() {
      if (this.isOnResultPage) {
        this.STRAP_SEARCH_SET_WATCH_REF(this.searchValue);
        window.history.pushState({ reference: this.watchReference }, this.watchReference, this.searchResultLink.search);
        await this.getStraps();
        return;
      }

      window.location.assign(this.searchResultLink.href);
    },
  },
};
